/**
 * Helper functions for reservation management
 */

export const stripHtmlTags = (html: string): string => {
  if (!html) {
    return ''
  }

  let text = html.replace(/<br\s*\/?>/gi, '\n')
  text = text.replace(/<\/(p|div)>/gi, '\n\n')
  text = text.replace(/<[^>]*>/g, '')

  const textarea = document.createElement('textarea')
  textarea.innerHTML = text
  text = textarea.value
  text = text.replace(/\n\s*\n\s*\n/g, '\n\n')
  text = text.trim()

  return text
}

export const downloadPdf = (base64: string, filename: string) => {
  try {
    const byteCharacters = atob(base64)

    const byteNumbers = Array.from(byteCharacters, char => char.charCodeAt(0))
    const byteArray = new Uint8Array(byteNumbers)
    const blob = new Blob([byteArray], {type: 'application/pdf'})

    const link = document.createElement('a')
    link.href = window.URL.createObjectURL(blob)
    link.download = filename
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
  } catch (error) {
    console.error('Error in downloadPdf:', error)
  }
}

// Delay between downloads to prevent browser popup blocking
const DOWNLOAD_DELAY_MS = 500

export const downloadAllPdfsSequentially = async (
  pdfList: {base64: string; filename: string}[]
) => {
  for (const pdf of pdfList) {
    downloadPdf(pdf.base64, pdf.filename)
    await new Promise(res => setTimeout(res, DOWNLOAD_DELAY_MS))
  }
}
